<app-dialog [visible]="visible" [width]="width" [showCloseButton]="closable" (closed)="handleHide()">

    <ng-template #headerTemplate>
        <ng-container *ngIf="headerContentTemplate; else defaultHeader">
            <ng-container *ngTemplateOutlet="headerContentTemplate" />
        </ng-container>
        <ng-template #defaultHeader>
            <div class="delete-confirmation-header-row">
                <div class="delete-confirmation-icon">
                    <i class="pi pi-minus" aria-hidden="true"></i>
                </div>
                <div class="delete-confirmation-text-block">
                    <h2 class="delete-confirmation-title">{{ headerText }}</h2>
                </div>
            </div>
        </ng-template>
    </ng-template>

    <ng-template #bodyTemplate>
        <ng-container *ngIf="bodyContentTemplate; else defaultBody">
            <ng-container *ngTemplateOutlet="bodyContentTemplate" />
        </ng-container>
        <ng-template #defaultBody>
            <p class="text-md text-gray-700">{{ bodyText }}</p>
        </ng-template>

        <div *ngIf="zipDownloadTemplate" class="delete-confirmation-extra mb-4">
            <ng-container *ngTemplateOutlet="zipDownloadTemplate"></ng-container>
        </div>

        <div *ngIf="requireConfirmation" class="delete-confirmation-extra mt-2 mb-4">
            <label for="confirmationInput" class="block text-sm font-medium text-gray-600 mb-1">
                Please type <span class="font-bold">{{ confirmationText }}</span> to confirm
            </label>
            <input id="confirmationInput" pInputText [(ngModel)]="confirmationInput"
                placeholder="{{ confirmationText }}" class="w-full border focus:!border-red-500 rounded p-2 truncate"
                autocomplete="off" />
        </div>
    </ng-template>

    <ng-template #footerTemplate>
        <ng-container *ngIf="footerContentTemplate; else defaultFooter">
            <ng-container *ngTemplateOutlet="footerContentTemplate" />
        </ng-container>
        <ng-template #defaultFooter>
            <div class="delete-confirmation-footer">
                <div class="delete-confirmation-cancel-btn">
                    <app-button variant="filled" severity="contrast" label="Cancel" (clicked)="handleCancel()"
                        [disabled]="loading" />
                </div>
                <div class="delete-confirmation-delete-btn">
                    <app-button variant="filled" severity="danger" [label]="confirmButtonText" [loading]="loading"
                        [disabled]="isSaveDisabled" (clicked)="handleConfirm()" />
                </div>
            </div>
        </ng-template>
    </ng-template>
</app-dialog>
